/** 逆地理接口完整路径前缀（不含 ? 及参数），默认由本地后端保护天地图 Key。 */
export function getTiandituGeocoderBaseUrl() {
  const fromEnv = process.env.VUE_APP_TIANDITU_GEOCODER_BASE
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).replace(/\/$/, '')
  }
  const baseApi = String(process.env.VUE_APP_BASE_API || '').replace(/\/$/, '')
  return `${baseApi}/webserver/waybill/geocoder/reverse`
}
